import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

function PieChart({ serie, labeld }) {

    const label = labeld ? labeld : ['200', '406', '409', '422']
    //console.log(label)
    //console.log(serie)
    // //console.log(chartData)
    // const chartSeries = serie ? serie : [44, 55, 13, 43]
    const [ChartData, setChartData] = useState({

        // series: chartSeries,
        options: {
            chart: {
                width: 380,
                type: 'pie',
            },
            labels: label,
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    });
    useEffect(() => {
        if (labeld) {
            setChartData(prevChartData => ({
                options: {
                    ...prevChartData.options,
                    labels: label
                }
            }));
        }

    }, [labeld])

    if (serie.every(value => value === 0)) {
        return (
            <div align='center' style={{ padding: '40px', margin: '15%' }}>No data</div>
        )
    }

    return (
        <>
            <ReactApexChart options={ChartData.options} series={serie} type="pie" height={250} />
        </>
    )
}


export default PieChart